<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">Reporte Cajas</v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.esperando }}</td>
              <td class="text-xs-left">{{ props.item.recibidos }}</td>
              <td class="text-xs-left">{{ props.item.faltantes }}</td>
              <td class="text-xs-left">
                {{ props.item.porcentaje.toFixed(1) }}%
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <!-- descarga informe -->
      <v-dialog v-model="loadingInforme" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaInforme()"
        >
          Descarga informe
          <v-icon right dark>folder</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "recepcionCap-reporteCajas",

  components: {
    Loading,
    LoadingDescarga,
    AlertEmpty,
  },
  props: {},
  data() {
    return {
      idContrato: "",
      items: [],
      loading: false,
      alerta: false,
      botonDescarga: false,
      loadingInforme: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        {
          text: "Tipo Prueba",
          align: "left",
          sortable: false,
          value: "tipo_prueba",
        },
        { text: "Esperado", sortable: false, value: "esperado" },
        { text: "Actual", sortable: false, value: "actual" },
        { text: "Faltantes", sortable: false, value: "faltantes" },
        { text: "Procentaje recepción", sortable: false, value: "porcentaje" },
      ],
    };
  },

  computed: {},

  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;

      this.items = await this.loadReporteCajas();

      if (this.items.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    async loadReporteCajas() {
      //alert(this.idContrato + " ID C");

      return await axios
        .get("/capturaRecepcion/reporteCajas/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async descargaInforme() {
      this.loadingDescarga = true;
      // var nombreArchivo = "INFORME_" + this.producto.descripcion.replaceAll(/[^a-zA-Z0-9-]+/, "_") + ".xlsx";

      return await axios
        .get("/capturaRecepcion/descargaReporteCajas/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;

          link.setAttribute("download", "Rep_resumen_cajas_recepcion.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          if (error) {
            window.getApp.$emit(
              "ERROR_EXCEPTION",
              "Ha ocurrido un error al generar la descarga"
            );
          }
        });
    },
  },
};
</script>
